import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { SqlService } from '../../Database/sql.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  public ActivePage = "";
  public UserLevel = "none";


  constructor(private dbService: SqlService, private router: Router) { }

  ngOnInit(): void {
    this.UserLevel = this.dbService.getUserLevel();
    this.ActivePage = String(localStorage.getItem('ActivePage'));
  }


  changePage(nextPage: string) {

    this.ActivePage = nextPage;

    localStorage.setItem('ActivePage', nextPage);

    switch (nextPage) {
      case "AgentView":
        this.router.navigate(['ViewAgent']);
        this.ActivePage = "Agent";
        break;
      case "AgentAdd":
        this.router.navigate(['AddAgent']);
        this.ActivePage = "Agent";
        break;
      case "ClientView":
        this.router.navigate(['ViewClient']);
        this.ActivePage = "Client";
        break;
      case "ClientAdd":
        this.router.navigate(['AddClient']);
        this.ActivePage = "Client";
        break;
      case "AreasView":
        this.router.navigate(['ViewArea']);
        this.ActivePage = "Areas";
        break;
      case "AreasAdd":
        this.router.navigate(['AddArea']);
        this.ActivePage = "Areas";
        break;
      case "Provinces":
        this.router.navigate(['ViewProvinces']);
        break;
      case "DistributorsView":
        this.router.navigate(['ViewDistributors']);
        this.ActivePage = "Distributors";
        break;
      case "DistributorsAdd":
        this.router.navigate(['AddDistributors']);
        this.ActivePage = "Distributors";
        break;
      case "ProvidersView":
        this.router.navigate(['ViewProviders']);
        this.ActivePage = "Providers";
        break;
      case "ProvidersAdd":
        this.router.navigate(['AddProviders']);
        this.ActivePage = "Providers";
        break;
      case "BranchesView":
        this.router.navigate(['ViewBranches']);
        this.ActivePage = "Branches";
        break;
      case "BranchesAdd":
        this.router.navigate(['AddBranches']);
        this.ActivePage = "Branches";
        break;
      case "UsersView":
        this.router.navigate(['ViewUsers']);
        this.ActivePage = "Users";
        break;
      case "UsersAdd":
        this.router.navigate(['AddUsers']);
        this.ActivePage = "Users";
        break;
      case "ImportBox":
        this.router.navigate(['ScanBox']);
        this.ActivePage = "Boxes";
        break;
      case "PrepareBatches":
        this.router.navigate(['PrepareBatches']);
        this.ActivePage = "Boxes";
        break;
      case "AllocateDistributor":
        this.router.navigate(['AllocateDistributor']);
        this.ActivePage = "Boxes";
        break;
      case "TransferBranch":
        this.router.navigate(['TransferBranch']);
        this.ActivePage = "Boxes";
        break;
      case "AllocateClients":
        this.router.navigate(['AllocateClients']);
        this.ActivePage = "Boxes";
        break;
      case "ViewBox":
        this.router.navigate(['ViewBoxes']);
        this.ActivePage = "Boxes";
        break;
      case "SelectSuperviser":
        this.router.navigate(["SelectSuperviser"]);
        this.ActivePage = "Direct";
        break;
      case "ViewDirectBoxes":
        this.router.navigate(["ViewDirectBoxes"]);
        this.ActivePage = "Direct";
        break;
      case "SelectAgent":
        this.router.navigate(["SelectAgent"]);
        this.ActivePage = "Direct";
        break;
      case "AdminReSelectAgent":
        this.router.navigate(["AdminReSelectAgent"]);
        this.ActivePage = "Direct";
        break;
      case "AdminDeleteBoxes":
        this.router.navigate(["AdminDeleteBoxes"]);
        this.ActivePage = "Admin";
        break;
      case "AdminViewAuditLog":
        this.router.navigate(["AdminViewAuditLog"]);
        this.ActivePage = "Admin";
        break;
      case "AdminDashboard":
        this.router.navigate(["AdminDashboard"]);
        this.ActivePage = "Admin";
        break;
      case "AppReports":
        this.router.navigate(["AppReports"]);
        this.ActivePage = "Admin";
        break;
      default:
        // Handle cases where nextPage doesn't match any condition
        console.error("Invalid nextPage value:", nextPage);
        break;
    }

    if (document.getElementById("MobileViewHeadingButton") != null) {
      document.getElementById("MobileViewHeadingButton")?.click();
    }
  }

}
